import styled from 'styled-components';
import { default as BoneyardButton } from '@g4/boneyard/lib/Button';

const getAnimationStyles = props => {
  const defaultAnimationStyles = `
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: -50%;
      width: 0;
      height: 100%;
      border-radius: inherit;
      background: rgba(255, 255, 255, 0.6);
      transform: skew(-50deg);
      transition: none;
    }

    &:hover {
      &::after {
        width: 200%;
        background: rgba(255, 255, 255, 0);
        transition: all 0.5s ease-in-out;
      }
    }
  `;

  const animationStyles = {
    primary: defaultAnimationStyles,
    secondary: `
      ${defaultAnimationStyles}    
      &:hover {
        &::before {
          background: ${props.theme.colors.button.primary};
        }
      }
    `,
  };

  return (!props.disabled && animationStyles[props.type]) || null;
};

const Button = styled(BoneyardButton)`
  position: relative;
  overflow: hidden;

  &:focus {
    outline: 0;
    box-shadow: 0 0 0 4px ${props => props.theme.colors.hob.input.focused};
  }

  ${getAnimationStyles}
`;

export default Button;
